import { ClientContext } from '../../core/ClientContextFactory';
import { CheckoutUXFlow } from '../../enums/Checkout';
import {
  CheckoutOptions,
  SinglePaymentMethodCheckoutOptions,
  VaultManagerOptions,
} from '../../types';
import { Checkout } from './Checkout';
import { SinglePaymentMethodCheckout } from './SinglePaymentMethodCheckout';
import { VaultManager } from './VaultManager';

type FlowOptions =
  | CheckoutOptions
  | VaultManagerOptions
  | SinglePaymentMethodCheckoutOptions;

const FlowFactory = {
  create: async (
    getContext: () => Promise<ClientContext>,
    options: FlowOptions,
  ) => {
    switch (options.uxFlow) {
      case CheckoutUXFlow.CHECKOUT:
        return Checkout.create(getContext, options as CheckoutOptions);
      case CheckoutUXFlow.MANAGE_PAYMENT_METHODS:
        return VaultManager.create(getContext, options as VaultManagerOptions);
      case CheckoutUXFlow.SINGLE_PAYMENT_METHOD_CHECKOUT:
        return SinglePaymentMethodCheckout.create(
          getContext,
          options as SinglePaymentMethodCheckoutOptions,
        );
      default:
        return Checkout.create(getContext, options as CheckoutOptions);
    }
  },
};

export default FlowFactory;
